// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".config-name[data-v-b95f1500] {\n  width: 189px;\n}\n.topology[data-v-b95f1500] {\n  width: 270px;\n}\n.server-version[data-v-b95f1500] {\n  width: 250px;\n}\n.version[data-v-b95f1500] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
